"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import _ from "lodash";
import API from "@ym-framework/api-utils";
import { Component, PropSync, Ref, Vue } from "vue-property-decorator";
import PaymentNewVdInfo from "@/views/payItems/components/PaymentNewVdInfo.vue";
import PaymentNewCateGory from "@/views/payItems/components/PaymentNewCateGory.vue";
import PaymentNewDeviceInfo from "@/views/payItems/components/PaymentNewDeviceInfo.vue";
import PaymentNewComputerConfig from "@/views/payItems/components/PaymentNewComputerConfig.vue";
import PaymentNewDateOptions from "@/views/payItems/components/PaymentNewDateOptions.vue";
import PaymentNewDashboards from "@/views/payItems/components/PaymentNewDashboards.vue";
import PaymentNewDiscounts from "@/views/payItems/components/paymentNewDiscounts.vue";
import PaymentNewPayOptions from "@/views/payItems/components/PaymentNewPayOptions.vue";
import PaymentNewWays from "@/views/payItems/components/PaymentNewWays.vue";
import PaymentNewCostComponent from "@/views/payItems/components/PaymentNewCostComponent.vue";
import { CategorieIds, PaymentController } from "@/service/newProdect";
import ChangePayPalAccountDialog from "@/views/managements/accountmanager/components/dialog/ChangePayPalAccountDialog.vue";
let PaymentNewView = class extends Vue {
  constructor() {
    super(...arguments);
    this.options = new PaymentController();
    this.status = "ready";
    //价格计算
    this.calculation = _.debounce(() => __async(this, null, function* () {
      this.checkPaymentType();
      yield this.calculations();
    }), 800);
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      if (this.payment_style === "create") {
        if (this.recommand_type !== "") {
          let response = yield API.get(
            `api://base.auth/api/v8/payment/recomment/ipregion`,
            {
              params: {
                type: "recommend"
              }
            }
          );
          const categorieids = new CategorieIds();
          categorieids.types = response.data.type === null ? "" : (_a = response.data.type.id) != null ? _a : "";
          categorieids.regions = response.data.region === null ? "" : (_b = response.data.region.id) != null ? _b : "";
          categorieids.areas = response.data.area === null ? "" : (_c = response.data.area.id) != null ? _c : "";
          categorieids.remotes = response.data.remote === null ? "" : (_d = response.data.remote.id) != null ? _d : "";
          categorieids.models = response.data.model === null ? "" : (_e = response.data.model.id) != null ? _e : "";
          categorieids.categorys = response.data.service_provide === null ? "" : (_f = response.data.service_provide.id) != null ? _f : "";
          console.log(categorieids);
          yield this.options.selectCategorieByIds(categorieids);
          yield this.calculation();
          this.$emit("loadingReady", true);
          return;
        }
        if (this.recommand_id !== "") {
          this.options.selected.searchParams = {
            type: "NEW_BUY",
            selected: this.recommand_top_category
          };
          yield this.options.search();
          let category = this.options.findByIdAll(this.recommand_id);
          const categorieids = new CategorieIds();
          categorieids.types = category.types === null ? "" : (_g = category.types.id) != null ? _g : "";
          categorieids.regions = category.regions === null ? "" : (_h = category.regions.id) != null ? _h : "";
          categorieids.areas = category.areas === null ? "" : (_i = category.areas.id) != null ? _i : "";
          categorieids.remotes = category.remotes === null ? "" : (_j = category.remotes.id) != null ? _j : "";
          yield this.options.selectCategorieByIds(categorieids);
          yield this.calculation();
          this.$emit("loadingReady", true);
          return;
        }
        if (this.is_delete !== null && this.is_delete !== false && this.is_delete !== void 0) {
          this.options.selected.searchParams = {
            type: "RECOVER",
            shopGuid: this.shop_guid
          };
          yield this.options.search();
          yield this.calculation();
          this.$emit("loadingReady", true);
          return;
        }
        this.options.selected.searchParams = {
          type: "NEW_BUY",
          selected: this.recommand_top_category
        };
        yield this.options.search();
      }
      if (this.payment_style === "renew") {
        this.options.selected.virtualDesktopInfo = this._items;
        let _ids = this.getOldVdIds();
        this.options.renewSearch(_ids);
      }
      if (this.payment_style === "update") {
        this.options.selected.virtualDesktopInfo = this._items;
        let _ids = this.getOldVdIds();
        this.options.selected.searchParams = {
          virtual_desktop_id: _ids[0],
          type: "UPGRADE"
        };
        yield this.options.search();
      }
      if (this.payment_style === "recycle") {
        this.options.selected.virtualDesktopInfo = this._items;
        let _ids = this.getOldVdIds();
        this.options.selected.searchParams = {
          virtual_desktop_id: _ids[0],
          type: "RECOVER"
        };
        yield this.options.search();
      }
      yield this.calculation();
      this.$emit("loadingReady", true);
    });
  }
  showLoading(data) {
    this.$emit("loadingReady", data);
  }
  changeTopGroup() {
    this._payment_new_computer_config.changeShowFlag();
  }
  //获取优惠信息
  getDiscounts() {
    let discounts = [];
    if (this.options.selected.paymentGoldbeanUsed > 0) {
      discounts.push({
        type: "point",
        value: this.options.selected.paymentGoldbeanUsed
      });
    }
    if (this.options.selected.paymentCoupon !== null) {
      discounts.push({
        type: "discount_coupon",
        value: this.options.selected.paymentCoupon.guid
      });
    }
    if (this.options.selected.paymentDiscountCode !== null && this.options.selected.paymentDiscountCode !== "") {
      discounts.push({
        type: "discount_code",
        value: this.options.selected.paymentDiscountCode
      });
    }
    return discounts;
  }
  // base.auth.pro
  getDisountsPro() {
    let discounts = [];
    if (this.options.selected.paymentCoupon !== null) {
      discounts.push({
        type: "discount_coupon",
        value: this.options.selected.paymentCoupon.guid
      });
    }
    if (this.options.selected.paymentDiscountCode !== null && this.options.selected.paymentDiscountCode !== "") {
      discounts.push({
        type: "discount_code",
        value: this.options.selected.paymentDiscountCode
      });
    }
    if (this.options.selected.paymentVdcard !== null) {
      discounts.push({
        type: "vd_card",
        value: this.options.selected.paymentVdcard.guid
      });
    }
    return discounts;
  }
  //获取vd卡信息
  getPayCards() {
    let payCards = [];
    if (this.options.selected.paymentVdcard !== null) {
      payCards.push({
        guid: this.options.selected.paymentVdcard.guid
      });
    }
    return payCards;
  }
  //获取vd id
  gerVdIds() {
    let _ids = [];
    for (let item of this.options.selected.virtualDesktopInfo) {
      _ids.push(item.id);
    }
    return _ids;
  }
  //获取old vd id
  getOldVdIds() {
    let _ids = [];
    for (let item of this.options.selected.virtualDesktopInfo) {
      if (item.oldId) {
        _ids.push(item.oldId);
      } else if (item.config.oldId) {
        _ids.push(item.config.oldId);
      }
    }
    return _ids;
  }
  //新购，价格计算查询参数
  getPaymentDatas() {
    let discounts = this.getDisountsPro();
    return {
      discounts,
      type: "NEW",
      goodsSpecGuid: this.options.selected.goods.id,
      coin: this.options.selected.paymentGoldbeanUsed,
      quantity: this.options.selected.paymentQuantity,
      payType: this.options.selected.paymentType,
      productId: this.options.selected.categorys.id
    };
  }
  //续费，价格计算查询参数
  getRenewPaymentDatas() {
    let discounts = this.getDisountsPro();
    return {
      discounts,
      type: "RENEW",
      vdIds: this.gerVdIds(),
      goodsSpecGuid: this.options.selected.goods.id,
      coin: this.options.selected.paymentGoldbeanUsed,
      // quantity: this.options.selected.paymentQuantity,
      // 修参数
      quantity: 1,
      payType: this.options.selected.paymentType
    };
  }
  //升级恢复，价格计算查询参数
  getUpdatePaymentDatas() {
    let discounts = this.getDisountsPro();
    if (this.payment_style === "update") {
      return {
        discounts,
        type: "UPGRADE",
        vdIds: this.gerVdIds(),
        goodsSpecGuid: this.options.selected.goods.id,
        coin: this.options.selected.paymentGoldbeanUsed,
        // quantity: this.options.selected.paymentQuantity,
        quantity: 1,
        payType: this.options.selected.paymentType,
        productId: this.options.selected.categorys.id
      };
    } else {
      return {
        discounts,
        type: "RECOVER",
        vdIds: this.gerVdIds(),
        goodsSpecGuid: this.options.selected.goods.id,
        coin: this.options.selected.paymentGoldbeanUsed,
        // quantity: this.options.selected.paymentQuantity,
        quantity: 1,
        payType: this.options.selected.paymentType,
        productId: this.options.selected.categorys.id
      };
    }
  }
  checkPaymentType() {
    var _a;
    if (((_a = this.options.selected.categorys) == null ? void 0 : _a.payment.includes(this.options.selected.paymentType)) === false) {
      if (this.options.selected.categorys.payment[0] !== "vdcard") {
        this.options.selected.paymentType = this.options.selected.categorys.payment[0];
      } else {
        this.options.selected.paymentType = this.options.selected.categorys.payment[1];
      }
    }
  }
  calculations() {
    return __async(this, null, function* () {
      if (this.payment_style === "create") {
        yield this.calculationCreate();
      }
      if (this.payment_style === "renew") {
        yield this.calculationRenew();
      }
      if (this.payment_style === "update" || this.payment_style === "recycle") {
        yield this.calculationUpdate();
      }
    });
  }
  //获取金豆余额
  getGoldbean() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v7/payment/account/coins`
        );
        this.options.selected.paymentGoldbeanCoins = response.data.account_coins.coins;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //新购
  calculationCreate() {
    return __async(this, null, function* () {
      this.options.selected.paymentLoading = true;
      yield this.getGoldbean();
      if (this.options.selected.paymentQuantity > this.options.selected.categorys.limit.max) {
        this.options.selected.paymentQuantity = this.options.selected.categorys.limit.max;
      }
      if (this.options.selected.paymentQuantity < this.options.selected.categorys.limit.min) {
        this.options.selected.paymentQuantity = this.options.selected.categorys.limit.min;
      }
      try {
        let response = yield API.post(
          `api://base.auth.pro/v1/calculate`,
          this.getPaymentDatas()
        );
        this.calculationTidy(response.data);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.options.selected.paymentLoading = false;
      }
    });
  }
  //续期
  calculationRenew() {
    return __async(this, null, function* () {
      this.options.selected.paymentLoading = true;
      yield this.getGoldbean();
      try {
        let response = yield API.post(
          `api://base.auth.pro/v1/calculate`,
          this.getRenewPaymentDatas()
        );
        this.calculationTidy(response.data);
        this.options.selected.paymentLoading = false;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.options.selected.paymentLoading = false;
      }
    });
  }
  //升降级/恢复
  calculationUpdate() {
    return __async(this, null, function* () {
      this.options.selected.paymentLoading = true;
      yield this.getGoldbean();
      try {
        let response = yield API.post(
          `api://base.auth.pro/v1/calculate`,
          this.getUpdatePaymentDatas()
        );
        this.calculationTidy(response.data);
        this.options.selected.paymentLoading = false;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.options.selected.paymentLoading = false;
      }
    });
  }
  //计算数据整理
  // base.auth.pro
  calculationTidy(_data) {
    return __async(this, null, function* () {
      var _a;
      this.options.selected.goods.currency = _data.currency;
      this.options.selected.paymentCost = _data.payPrice;
      this.options.selected.paymentCodeError = null;
      this.options.selected.paymentCodeType = null;
      this.options.selected.paymentDesc = _data.desc || null;
      this.options.selected.paymentOriginalCost = _data.originalPrice;
      this.options.selected.paymentGoldbeanUsed = this.options.selected.paymentGoldbeanUsed ? this.options.selected.paymentGoldbeanUsed : 0;
      this.options.selected.paymentGoldbeanLeft = this.options.selected.paymentGoldbeanCoins - _data.coin;
      this.options.selected.paymentGoldbeanLimit = Math.min(
        _data.maxCoin,
        this.options.selected.paymentGoldbeanCoins
      );
      if (this.options.selected.paymentType !== "paypal" && this.options.selected.paymentType !== "payssion.alipay" && this.options.selected.paymentType !== "payssion.wechat") {
        this.options.selected.paymentGoldbeanUsed = Math.min(
          this.options.selected.paymentGoldbeanUsed,
          this.options.selected.paymentGoldbeanLimit
        );
      }
      if (_data.errorMessage && _data.errorMessage !== "") {
        this.options.selected.paymentCodeError = _data.errorMessage;
      }
      if (!_data.discountCoupon || _data.discountCoupon.type === null) {
        this.options.selected.paymentCoupon = null;
        this.options.selected.paymentVdcard = null;
      } else {
        if (_data.discountCoupon.type === "discount_code" && _data.discountCoupon.name !== null) {
          this.options.selected.paymentCodeType = _data.discountCoupon.name;
        }
      }
      if ((this.options.selected.paymentType === "paypal" || this.options.selected.paymentType === "payssion.alipay" || this.options.selected.paymentType === "payssion.wechat") && (this.options.selected.paymentGoldbeanUsed || this.options.selected.paymentDiscountCode)) {
        let paymentType = _.find((_a = this.options.selected.categorys) == null ? void 0 : _a.payments, { "payment": this.options.selected.paymentType });
        if (paymentType && paymentType.useCoin === false) {
          this.$message.warning(this.$t("paymentdiscounts.payment_warning_goldbean"));
          this.options.selected.paymentGoldbeanUsed = 0;
          yield this.calculations();
        }
        if (paymentType && paymentType.useCoupon === false) {
          this.$message.warning(this.$t("paymentdiscounts.payment_warning_coupon"));
          this.options.selected.paymentCoupon = null;
          this.options.selected.paymentDiscountCode = "";
          yield this.calculations();
        }
      }
    });
  }
  //提交订单 新购
  payment(shop_id, recommand) {
    return __async(this, null, function* () {
      let discounts = this.getDiscounts();
      let pay_vdcards = this.getPayCards();
      let shop_guid = null;
      if (shop_id !== "" && shop_id !== null) {
        shop_guid = shop_id;
      }
      let order_source = null;
      if (recommand !== "" && recommand !== null) {
        order_source = "NOVICE_GUIDE";
      }
      let payment_data = {
        callback: "https://app.kuajingvs.com/paymentcomplete",
        discounts,
        pay_type: this.options.selected.paymentType,
        pay_vdcards,
        product: {
          auto_renew: this.options.selected.paymentAutoRenew,
          //{{$t('paymentview.missing')}}auto_resolution
          auto_resolution: this.options.selected.configAutoResolution,
          //{{$t('paymentview.missing')}}auto_tiemzone
          auto_timezone: this.options.selected.configAutoTimezone,
          browser_guid: this.options.selected.configBrowser.id,
          country_guid: this.options.selected.configCountrie.id,
          goods_spec_guid: this.options.selected.goods.id,
          language_guid: this.options.selected.configLanguage.id,
          region_guid: this.options.selected.categorys.id,
          // system_guid: this.options.selected.configSystem.id,
          timezone_guid: this.options.selected.configTimezone.id,
          screen: this.options.selected.configResolution.name,
          unify_os: this.options.selected.configSystemUnify,
          os: {
            unify: this.options.selected.configSystemUnifyOs
          },
          userAgent: {
            unifyUa: this.options.selected.configSystemUnifyUa
          }
        },
        quantity: this.options.selected.paymentQuantity,
        user_input: {},
        shop_id: shop_guid,
        order_source
      };
      if (!this.options.selected.configSystemUnify) {
        payment_data.product.os.windows = this.options.selected.configSystemWindows;
        payment_data.product.userAgent.winUa = this.options.selected.configSystemWindowsUa;
        payment_data.product.os.mac = this.options.selected.configSystemMac;
        payment_data.product.userAgent.macUa = this.options.selected.configSystemMacUa;
        payment_data.product.os.android = this.options.selected.configSystemAndroid;
        payment_data.product.userAgent.androidUa = this.options.selected.configSystemAndroidUa;
        payment_data.product.os.linux = this.options.selected.configSystemLinux;
        payment_data.product.userAgent.linuxUa = this.options.selected.configSystemLinuxUa;
      }
      let response = yield API.post(
        `api://base.auth/api/v7/orders/vd_new/pay`,
        payment_data
      );
      this.options.selected.paymentGoldbeanUsed = 0;
      let model = response.data;
      if (response.data.order) {
        model.gift = response.data.order.pay_money <= 0;
      } else {
        model.gift = false;
      }
      return model;
    });
  }
  //提交订单 新购并创建默认店铺
  paymentCreateDefault(shop_id, recommand) {
    return __async(this, null, function* () {
      let discounts = this.getDiscounts();
      let pay_vdcards = this.getPayCards();
      let shop_guid = null;
      if (shop_id !== "" && shop_id !== null) {
        shop_guid = shop_id;
      }
      let order_source = null;
      if (recommand !== "" && recommand !== null) {
        order_source = "NOVICE_GUIDE";
      }
      let payment_data = {
        callback: "https://app.kuajingvs.com/paymentcomplete",
        discounts,
        pay_type: this.options.selected.paymentType,
        pay_vdcards,
        product: {
          auto_renew: this.options.selected.paymentAutoRenew,
          //{{$t('paymentview.missing')}}auto_resolution
          auto_resolution: this.options.selected.configAutoResolution,
          //{{$t('paymentview.missing')}}auto_tiemzone
          auto_timezone: this.options.selected.configAutoTimezone,
          browser_guid: this.options.selected.configBrowser.id,
          default_shop: true,
          country_guid: this.options.selected.configCountrie.id,
          goods_spec_guid: this.options.selected.goods.id,
          language_guid: this.options.selected.configLanguage.id,
          region_guid: this.options.selected.categorys.id,
          // system_guid: this.options.selected.configSystem.id,
          timezone_guid: this.options.selected.configTimezone.id,
          screen: this.options.selected.configResolution.name,
          // screen:null,
          unify_os: this.options.selected.configSystemUnify,
          os: {
            unify: this.options.selected.configSystemUnifyOs
          },
          userAgent: {
            unifyUa: this.options.selected.configSystemUnifyUa
          }
        },
        quantity: this.options.selected.paymentQuantity,
        user_input: {},
        shop_id: shop_guid,
        order_source
      };
      if (!this.options.selected.configSystemUnify) {
        payment_data.product.os.windows = this.options.selected.configSystemWindows;
        payment_data.product.userAgent.winUa = this.options.selected.configSystemWindowsUa;
        payment_data.product.os.mac = this.options.selected.configSystemMac;
        payment_data.product.userAgent.macUa = this.options.selected.configSystemMacUa;
        payment_data.product.os.android = this.options.selected.configSystemAndroid;
        payment_data.product.userAgent.androidUa = this.options.selected.configSystemAndroidUa;
        payment_data.product.os.linux = this.options.selected.configSystemLinux;
        payment_data.product.userAgent.linuxUa = this.options.selected.configSystemLinuxUa;
      }
      let response = yield API.post(
        `api://base.auth/api/v7/orders/vd_new/pay`,
        payment_data
      );
      this.options.selected.paymentGoldbeanUsed = 0;
      let model = response.data;
      if (response.data.order) {
        model.gift = response.data.order.pay_money <= 0;
      } else {
        model.gift = false;
      }
      return model;
    });
  }
  //提交订单 续费
  paymentRenew() {
    return __async(this, null, function* () {
      let discounts = this.getDiscounts();
      let pay_vdcards = this.getPayCards();
      let payment_data = {
        auto_renew: this.options.selected.paymentAutoRenew,
        callback: "https://app.kuajingvs.com/paymentcomplete",
        discounts,
        pay_type: this.options.selected.paymentType,
        pay_vdcards,
        // object_guid_list: this.gerVdIds(),
        // base.auth.pro
        object_guid_list: this.getOldVdIds(),
        product: {
          goods_spec_guid: this.options.selected.goods.id
        },
        quantity: this.options.selected.paymentQuantity,
        user_input: {}
      };
      let response = yield API.post(
        `api://base.auth/api/v7/orders/vd_renew/pay_multi`,
        payment_data
      );
      let model = response.data;
      if (response.data.order) {
        model.gift = response.data.order.pay_money <= 0;
      } else {
        model.gift = false;
      }
      return model;
    });
  }
  //提交订单 升级/恢复
  paymentUpdate() {
    return __async(this, null, function* () {
      let discounts = this.getDiscounts();
      let pay_vdcards = this.getPayCards();
      let old_ids = this.getOldVdIds();
      let payment_data = {
        callback: "https://app.kuajingvs.com/paymentcomplete",
        discounts,
        pay_type: this.options.selected.paymentType,
        pay_vdcards,
        product: {
          auto_renew: this.options.selected.paymentAutoRenew,
          browser_guid: this.options.selected.configBrowser.id,
          country_guid: this.options.selected.configCountrie.id,
          goods_spec_guid: this.options.selected.goods.id,
          language_guid: this.options.selected.configLanguage.id,
          region_guid: this.options.selected.categorys.id,
          // system_guid: this.options.selected.configSystem.id,
          timezone_guid: this.options.selected.configTimezone.id,
          // screen:null
          unify_os: this.options.selected.configSystemUnify,
          os: {
            unify: this.options.selected.configSystemUnifyOs
          },
          userAgent: {
            unifyUa: this.options.selected.configSystemUnifyUa
          }
        },
        quantity: this.options.selected.paymentQuantity,
        user_input: {},
        upgrade_vd_guid: old_ids[0]
      };
      if (!this.options.selected.configSystemUnify) {
        payment_data.product.os.windows = this.options.selected.configSystemWindows;
        payment_data.product.userAgent.winUa = this.options.selected.configSystemWindowsUa;
        payment_data.product.os.mac = this.options.selected.configSystemMac;
        payment_data.product.userAgent.macUa = this.options.selected.configSystemMacUa;
        payment_data.product.os.android = this.options.selected.configSystemAndroid;
        payment_data.product.userAgent.androidUa = this.options.selected.configSystemAndroidUa;
        payment_data.product.os.linux = this.options.selected.configSystemLinux;
        payment_data.product.userAgent.linuxUa = this.options.selected.configSystemLinuxUa;
      }
      let response = yield API.post(
        `api://base.auth/api/v7/orders/vd_new/pay_upgrade`,
        payment_data
      );
      let model = response.data;
      if (response.data.order) {
        model.gift = response.data.order.pay_money <= 0;
      } else {
        model.gift = false;
      }
      return model;
    });
  }
  paymentCreate() {
    return __async(this, null, function* () {
      try {
        this.status = "submit";
        let payment = null;
        if (this.payment_style === "create") {
          payment = yield this.payment(this.shop_guid, this.recommand_top_category);
        }
        if (this.payment_style === "renew") {
          payment = yield this.paymentRenew();
        }
        if (this.payment_style === "update" || this.payment_style === "recycle") {
          payment = yield this.paymentUpdate();
        }
        if (this.options.selected.paymentType === "paypal") {
          if (payment.model === "paypal.account.nobind") {
            this._change_paypal_account_dialog.open();
            return;
          } else if (payment.model !== "payment.nomoney") {
            let newWindow = window.open("about:blank");
            newWindow.location.href = JSON.parse(payment.url).url;
          }
        }
        if (this.options.selected.paymentType === "payssion.alipay" || this.options.selected.paymentType === "payssion.wechat") {
          if (payment.model !== "payment.nomoney") {
            let newWindow = window.open("about:blank");
            newWindow.location.href = JSON.parse(payment.url).url;
          }
        }
        let _order_id = payment.order.id;
        let _qr_url = payment.url;
        let _gift = payment.gift;
        switch (this.options.selected.paymentType) {
          case "alipay":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "alipay",
                r: this.recommand_top_category,
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            this.status = "ready";
            break;
          case "wxpay":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "wechat",
                r: this.recommand_top_category,
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            this.status = "ready";
            break;
          case "vdcard":
            this.status = "ready";
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "vdcard",
                r: this.recommand_top_category,
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            break;
          case "paypal":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "paypal",
                r: this.recommand_top_category,
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            this.status = "ready";
            break;
          case "payssion.alipay":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "payssion.alipay",
                r: this.recommand_top_category,
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            this.status = "ready";
            break;
          case "payssion.wechat":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "payssion.wechat",
                r: this.recommand_top_category,
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            this.status = "ready";
            break;
        }
      } catch (error) {
        this.status = "ready";
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  paymentCreateShop() {
    return __async(this, null, function* () {
      try {
        this.status = "submit";
        let payment = null;
        payment = yield this.paymentCreateDefault(this.shop_guid, this.recommand_top_category);
        if (this.options.selected.paymentType === "paypal") {
          if (payment.model === "paypal.account.nobind") {
            this._change_paypal_account_dialog.open();
            return;
          } else if (payment.model !== "payment.nomoney") {
            let newWindow = window.open("about:blank");
            newWindow.location.href = JSON.parse(payment.url).url;
          }
        }
        if (this.options.selected.paymentType === "payssion.alipay" || this.options.selected.paymentType === "payssion.wechat") {
          let newWindow = window.open("about:blank");
          newWindow.location.href = JSON.parse(payment.url).url;
        }
        let _order_id = payment.order.id;
        let _qr_url = payment.url;
        let _gift = payment.gift;
        switch (this.options.selected.paymentType) {
          case "alipay":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "alipay",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            this.status = "ready";
            break;
          case "wxpay":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "wechat",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            this.status = "ready";
            break;
          case "vdcard":
            this.status = "ready";
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "vdcard",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            break;
          case "paypal":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "paypal",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            this.status = "ready";
            break;
          case "payssion.alipay":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "payssion.alipay",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            this.status = "ready";
            break;
          case "payssion.wechat":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "payssion.wechat",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: this.payment_style
              }
            });
            this.status = "ready";
            break;
        }
      } catch (error) {
        this.status = "ready";
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  stopLoading() {
    this.status = "ready";
  }
  goHelp(no) {
    window.open(`https://www.kuajingvs.com/help2/${no}`);
  }
};
__decorateClass([
  PropSync("paymentStyle", {
    type: String,
    default: function() {
      return "";
    }
  })
], PaymentNewView.prototype, "payment_style", 2);
__decorateClass([
  PropSync("virtualDesktopItems", {
    type: Array,
    default: function() {
      return new Array();
    }
  })
], PaymentNewView.prototype, "_items", 2);
__decorateClass([
  PropSync("shopId", {
    type: String,
    default: function() {
      return "";
    }
  })
], PaymentNewView.prototype, "shop_guid", 2);
__decorateClass([
  PropSync("recommand", {
    type: String,
    default: function() {
      return "";
    }
  })
], PaymentNewView.prototype, "recommand_top_category", 2);
__decorateClass([
  PropSync("isDelete")
], PaymentNewView.prototype, "is_delete", 2);
__decorateClass([
  PropSync("recommandId")
], PaymentNewView.prototype, "recommand_id", 2);
__decorateClass([
  PropSync("recommandType")
], PaymentNewView.prototype, "recommand_type", 2);
__decorateClass([
  Ref("payment-cost-component")
], PaymentNewView.prototype, "_paymentCostComponent", 2);
__decorateClass([
  Ref("payment-new-vd-info")
], PaymentNewView.prototype, "_paymentNewVdInfo", 2);
__decorateClass([
  Ref("change-paypal-account-dialog")
], PaymentNewView.prototype, "_change_paypal_account_dialog", 2);
__decorateClass([
  Ref("payment-new-computer-config")
], PaymentNewView.prototype, "_payment_new_computer_config", 2);
PaymentNewView = __decorateClass([
  Component({
    components: {
      PaymentNewCateGory,
      PaymentNewDeviceInfo,
      PaymentNewComputerConfig,
      PaymentNewDateOptions,
      PaymentNewDiscounts,
      PaymentNewPayOptions,
      PaymentNewWays,
      PaymentNewDashboards,
      PaymentNewCostComponent,
      PaymentNewVdInfo,
      ChangePayPalAccountDialog
    }
  })
], PaymentNewView);
export {
  PaymentNewView as default
};
